/**
 * Classe para gerenciar as tags de equipamento do mapa pincipal
 *
 * @author:  Daniel Laurindo / Kete M. Rufino
 * Date: 16/12/13
 * Time: 09:00
 */



Greenmile.Toolbar = Greenmile.Toolbar || {};
Greenmile.Toolbar.Map = Greenmile.Toolbar.Map || {};
Greenmile.Toolbar.Map.Tags = Greenmile.Toolbar.Map.Tags || {};

Greenmile.Toolbar.Map.Tags = function (map, mapSelector, action) {

    this.render = function () {
        var callback = function(tags) {
            this.tagsListRender(tags);
            if(action.setSelector) {
                action.setSelector(mapSelector);
            }
            var optionsMarked = action.getOptionSelected();
            if (optionsMarked && optionsMarked.length > 0) {
                action.markCheckBox(optionsMarked);
            }
            action.makeAction();
            action.addListeners();
        }.bind(this);
        
        action.getListTags(callback);
    };

    this.tagsListRender = function (tags) {

        if (!tags) {
            return;
        }
        var listUl   = mapSelector + " .tagsContainer." + action.classSelector + " ul",
            tagsList = document.querySelector(listUl);

        var renderedHTML = document.createElement('div'), template = Greenmile.Toolbar.Map.Layouts["#item_tags_template"];

        const selectAllText = Monet.I18n.getResourcesByKey("toolbar.hint.tags.geocode.selectAll");
        renderedHTML.appendChild(template(`${this._getSelectorString()}-${action.classSelector}-selectAll`, "", selectAllText));

        for (var i = 0; i < tags.length; i++) {
            tags[i].idComponent = tags[i].tagType + "-" + this._getSelectorString() + "-" + tags[i].id;
            renderedHTML.appendChild(template(tags[i].idComponent, action.classSelector, tags[i].description, tags[i].tagColor));
        }

        if (tagsList) {
            tagsList.innerHTML = renderedHTML.innerHTML;
        }

    };

    this._getSelectorString = () => mapSelector.replace(/[^0-9a-z]/gi, '');

    this.addListeners = function () {

        this.render();
        
    };

};